import { Loader2, Sparkles } from "lucide-react";
import React from "react";
import { useSelector } from "react-redux";

import { isAIEnabled } from "../../../../src/features/configs/logic/Slice";
import DocumentTooltip from "../../../../src/features/documentManagement/components/DocumentTooltip";
import { cn } from "../../../lib/utils";
import ButtonV2 from "../button/v2";

interface GenerateAIButtonProps {
  onClick?: () => void;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
}

export const renderButtonContent = (
  defaultText: string,
  loadingText: string,
  isLoadingFlag: boolean,
  IconComponent: React.ElementType,
) => (
  <>
    {isLoadingFlag ? (
      <Loader2 className="mr-2 h-4 w-4 animate-spin" />
    ) : (
      <IconComponent className="mr-2 h-4 w-4" />
    )}
    {isLoadingFlag ? loadingText : defaultText}
  </>
);

const GenerateAIButton: React.FC<GenerateAIButtonProps> = ({
  onClick,
  loading = false,
  disabled = false,
  className,
}) => {
  const aiEnabled = useSelector(isAIEnabled);
  const isButtonDisabled = disabled || !aiEnabled;

  const button = (
    <ButtonV2
      variant="ai-gradient"
      size="md"
      className={cn(
        "disabled:cursor-not-allowed disabled:opacity-80",
        className,
      )}
      onClick={onClick}
      disabled={isButtonDisabled}
      aria-busy={loading}
    >
      {renderButtonContent(
        "Generate with AI",
        "Generate with AI",
        loading,
        Sparkles,
      )}
    </ButtonV2>
  );

  if (!aiEnabled) {
    return (
      <DocumentTooltip content="AI features currently disabled due to lack of tenant integrations.">
        <span className="inline-flex">{button}</span>
      </DocumentTooltip>
    );
  }

  return button;
};

export default GenerateAIButton;
